// Libraries modules

import Vue from 'vue'
import App from './App.vue'
import Buefy from 'buefy'
import store from './store/store'
import 'buefy/lib/buefy.css'
import {library} from '@fortawesome/fontawesome-svg-core'
import {faPhone} from '@fortawesome/free-solid-svg-icons'
import {faMobile} from '@fortawesome/free-solid-svg-icons'
import {faAt} from '@fortawesome/free-solid-svg-icons'
import {faMapMarker} from '@fortawesome/free-solid-svg-icons'
import {faIdCard} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

import vuexI18n from 'vuex-i18n'
import VueAnalytics from 'vue-analytics'
Vue.use(vuexI18n.plugin, store)

// add translations directly to the application
import translationsPt from './translations/pt-PT/pt-PT'

Vue.use(Buefy)
Vue.use(VueAnalytics, {
    id: 'UA-111734311-1'
})

Vue.i18n.add('pt', translationsPt)
Vue.i18n.set('pt')


Vue.config.productionTip = false

library.add(faPhone)
library.add(faMobile)
library.add(faAt)
library.add(faMapMarker)
library.add(faIdCard)

Vue.component('font-awesome-icon', FontAwesomeIcon)


new Vue({
    render: h => h(App),
    store
}).$mount('#app')


